import { Routes, Route, Navigate } from 'react-router-dom'
import UserTeamManagement from '../pages/Admin/User/UserTeamManagement'
import ActivityConfig from '../pages/Admin/Template/ActivityConfig'
import ListsConfig from '../pages/Admin/Template/ListConfig'
import ListDataDependencyManagement from '../pages/Admin/Template/Lddm'
import Workflow from '../pages/Admin/Workflow/Workflow'
import AdminLandingPage from '../pages/Admin/LandingPage/AdminLandingPage'
import UserActivityAssignments from '../pages/Admin/User/UserActivityAssignments/UserActivityAssignments'
import ServerActionConfig from '../pages/Admin/ServerActionConfig/ServerActionConfig'
import NotificationSettings from '../pages/Admin/NotificationSettings/NotificationSettings'
import EmailRedirection from '../pages/Admin/NotificationSettings/components/EmailRedirection'
import CustomNotificationTemplates from '../pages/Admin/NotificationSettings/components/CustomNotificationTemplates'
import DocumentTemplates from '../pages/Admin/LandingPage/DocumentTemplates/DocumentTemplates'
import TBDManagement from '../pages/Admin/TBD/TBDManagement'
import ProcessAssignmentConfig from '../pages/Admin/ProcessAssignment/ProcessAssignmentConfig'
import Layout from '../components/Header/Layout'
import ProtectedActivityConfig from '../pages/Admin/Template/ProtectedActivityConfig'
import UserReplacement from '../pages/Admin/User/UserReplacement'
import UserManagement from '../pages/Admin/User/UserManagement'
const AdminRoutes = () => {
  return (
    <Layout>
      <Routes>
        <Route
          path="user-assignments/:activity_template_id"
          element={<UserActivityAssignments />}
        />
        <Route path="user-team" element={<UserTeamManagement />} />
        <Route path="users" element={<UserManagement />} />
        <Route path="activity-config/:activity_template_id" element={<ActivityConfig />} />
        <Route path="user-replacement" element={<UserReplacement />} />
        <Route path="lists" element={<ListsConfig />} />
        <Route path="lddm" element={<ListDataDependencyManagement />} />
        <Route path="process-workflow/:process_template_id" element={<Workflow />} />
        <Route path="/" element={<AdminLandingPage />} />
        <Route path="/server-actions/:type" element={<ServerActionConfig />} />
        <Route path="/notification-settings" element={<NotificationSettings />} />
        <Route path="/email-redirection" element={<EmailRedirection />} />
        <Route path="/custom-notification-templates" element={<CustomNotificationTemplates />} />
        <Route path="/docuement-templates" element={<DocumentTemplates />} />
        <Route path="/tbd" element={<TBDManagement />} />
        <Route path="/process-assignments" element={<ProcessAssignmentConfig />} />
        <Route path="/protected-activity-config" element={<ProtectedActivityConfig />} />
        {/* Default Route */}
        <Route path="*" element={<Navigate to={'/'} />} />
      </Routes>
    </Layout>
  )
}

export default AdminRoutes
